module.exports = __webpack_public_path__ + "static/media/chatImage.f0480dc9.svg";